import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {Col, Row, Container} from "reactstrap";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class WardFormData {
    @observable code = '';
    @observable name = '';
    @observable state_id: number|null = null;
    @observable is_active = true;
    @observable local_government_area_id: number|null = null;
}

export class WardForm extends CrudForm {
    modelName = 'Ward';

    renderFields() {
        return (
            <>
                <Field
                    label="Code"
                    name="code"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Ward"
                    name="name"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="State"
                    name="state_id"
                    component={Select}
                    required={true}
                    loadOptions={api.state.getListAction}
                    store={this.formStore}
                    onChange={() => {
                        this.formStore.setValue('local_government_area_id', null);
                    }}
                />

                <Field
                    key={this.formStore.getValue('state_id')}
                    label="Local Government Area"
                    name="local_government_area_id"
                    component={Select}
                    required={true}
                    valueObject={true}
                    loadOptions={() => {
                        return api.localGovernmentArea.getListAction({
                            filters: {
                                state_id: this.formStore.getValue('state_id')
                            }
                        });
                    }}
                    store={this.formStore}
                />

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                />
            </>
        );
    }
}

export class WardFilterForm {
    @observable state_id = null;
    @observable local_government_area_id = null;
}

export class WardList extends CrudList {
    modelName = 'Ward';
    defaultSortColumn = 'state.name';
    defaultSortDirection = 'asc';

    colums() {
        return [
            {
                name: "state.code",
                label: "State Code",
                sort: true,
            },
            {
                name: "state.name",
                label: "State",
                sort: true,
            },
            {
                name: "local_government_area.name",
                label: "LGA",
                sort: true,
            },
            {
                name: "name",
                label: "Ward",
                sort: true,
            },
            {
                name: "code",
                label: "Ward Code",
                sort: true,
            },
        ];
    }

    idColumn() {
        return '';
    }

    renderFilters() {
        return (
            <Container>
            <Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
            </Row>
            <Row className="form-row">
                <Col md={3} lg={4} xl={3}>
                    <Field
                        name="state_id"
                        placeholder="Select State"
                        component={Select}
                        loadOptions={api.state.getListAction}
                        store={this.filterFormStore}
                        onChange={() => {
                            this.filterFormStore.setValue('local_government_area_id', null);
                        }}
                    />
                </Col>

                <Col md={3} lg={4} xl={3}>
                    <Field
                        key={this.filterFormStore.getValue('state_id')}
                        name="local_government_area_id"
                        placeholder="Select LGA"
                        component={Select}
                        loadOptions={() => {
                            return api.localGovernmentArea.getListAction({
                                filters: {
                                    state_id: this.filterFormStore.getValue('state_id')
                                }
                            });
                        }}
                        store={this.filterFormStore}
                    />
                </Col>

                <Col md={3} lg={4} xl={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
            </Container>
        );
    }
}

export class WardPage extends CrudPage {
    modelName = 'Ward';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/WardPage.tsx